import React from "react";
import Select from "react-select";
import { useProtocolLOVs } from "protocol-setup/redux/useLovs";

export function LeadGroupFilter({
  name,
  label,
  gridController,
  lov,
  selectedLpoValue,
  setSelectedLpoValue,
  all
}) {
  return (
    <>
      <label htmlFor={`filter-${name}`} className="invisible">
        {label}
      </label>
      <Select
        value={selectedLpoValue}
        className="grid-reactSelect-wrapper"
        classNamePrefix="grid-reactSelect"
        id={`filter-id-${name}`}
        inputId={`filter-${name}`}
        data-id={`filter-${name}`}
        options={[all, ...lov]}
        name={name}
        defaultValue={all}
        menuPosition="absolute"
        menuPortalTarget={document.body}
        gridController={gridController}
        classNames={{
          option: () => `menu-item-${name}`
        }}
        blurInputOnSelect
        onChange={(option) => {
          setSelectedLpoValue(option);
          gridController.current.filterExternally({
            leadGrp: option?.value,
            protocolNumber: ''
          }, true, false);


        }}
        styles={{
          menuPortal: (base) => ({ ...base, minWidth: "10rem", zIndex: 999 })
        }}
      />
    </>
  );
}

export default function AssociatedProtocolFilter({
  name,
  label,
  gridController,
  selectedLpoValue,
  all
}) {
  const [selectedValue, setSelectedValue] = React.useState(all);
  const { protocolList } = useProtocolLOVs(selectedLpoValue?.value || "");

  return (
    <>
      <label htmlFor={`filter-${name}`} className="invisible">
        {label}
      </label>
      <Select
        value={selectedValue}
        className="grid-reactSelect-wrapper"
        classNamePrefix="grid-reactSelect"
        id={`filter-id-${name}`}
        inputId={`filter-${name}`}
        data-id={`filter-${name}`}
        options={[all, ...protocolList.map(item => ({ value: item.value, label: item.value }))]}
        name={name}
        defaultValue={all}
        menuPosition="absolute"
        menuPortalTarget={document.body}
        gridController={gridController}
        blurInputOnSelect
        classNames={{
          option: () => `menu-item-${name}`
        }}
        onChange={(option) => {
          setSelectedValue(option);
          gridController.current.filterExternally({
            protocolNumber: option?.value
          });
        }}
        styles={{
          menuPortal: (base) => ({ ...base, minWidth: "10rem", zIndex: 999 })
        }}
      />
    </>
  );
}
